import React from 'react';

export const SolLogo: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
  <svg version="1.1" viewBox="0 0 50 40" xmlns="http://www.w3.org/2000/svg">
    <g fill="#ffffff">
      <path d="m41.874 15.49c-0.3059-0.3136-0.7207-0.4897-1.1532-0.4897h-39.904c-0.72692 0-1.0908 0.9017-0.5766 1.4287l7.8849 8.0816c0.30594 0.3136 0.72072 0.4897 1.1532 0.4897h39.904c0.7269 0 1.0908-0.9017 0.5766-1.4287l-7.8849-8.0816z"/>
      <path d="m8.1257 30.535c0.30594-0.3121 0.72072-0.4874 1.1532-0.4874h39.904c0.7269 0 1.0908 0.8974 0.5766 1.4219l-7.8849 8.0429c-0.3059 0.3121-0.7207 0.4874-1.1532 0.4874h-39.904c-0.72692 0-1.0908-0.8973-0.5766-1.4219l7.8849-8.0429z"/>
      <path d="m8.1257 0.48736c0.30594-0.31206 0.72072-0.48736 1.1532-0.48736h39.904c0.7269 0 1.0908 0.89734 0.5766 1.4219l-7.8849 8.0429c-0.3059 0.31206-0.7207 0.48735-1.1532 0.48735h-39.904c-0.72692 0-1.0908-0.89734-0.5766-1.4219l7.8849-8.0429z"/>
    </g>
  </svg>
  );
};